import { useRef, useEffect } from "react";
import './CodigoInput.css';

export default function CodigoInput({ longitud = 6, onComplete }) {
    const inputs = useRef([]);

    useEffect(() => {
        inputs.current[0]?.focus();
    }, []);

    const handleChange = (e, idx) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        if (!value) return;

        e.target.value = value.charAt(0);

        if (idx < longitud - 1) {
            inputs.current[idx + 1]?.focus();
        }

        const code = inputs.current.map(i => i.value).join("");
        if (code.length === longitud) {
            onComplete(code);
        }
    };

    const handleKeyDown = (e, idx) => {
        if (e.key === "Backspace" && !e.target.value && idx > 0) {
            inputs.current[idx - 1]?.focus();
        }
    };

    return (
        <div className="codigo-input-container">
            {Array.from({ length: longitud }).map((_, idx) => (
                <input
                    key={idx}
                    type="text"
                    maxLength={1}
                    inputMode="numeric"
                    ref={el => inputs.current[idx] = el}
                    onChange={e => handleChange(e, idx)}
                    onKeyDown={e => handleKeyDown(e, idx)}
                    className="codigo-input-box"
                />
            ))}
        </div>
    );
}
